import TemplateView from "./TemplateView";
import DropdownTemplateView from "./DropdownTemplateView";
import ScrollView from "./ScrollView";
import {escapeHtmlSymbols} from "./atUtils";
import _ from 'underscore'
import $ from 'jquery'

export default class SimpleListMenu extends DropdownTemplateView {
    constructor({
        onItemClick = item => {},
        itemHtmlCallback = defaultItemHtmlCallback,
        extraClass,
        itemHeight = 20,
        onHide = () => {},
        onShow = () => {},
    }) {
        super(null, {
            onHide,
            onShow,
        })
        this.onItemClick = onItemClick;
        this.itemHtmlCallback = itemHtmlCallback;
        this.extraClass = extraClass;
        this.items = [];
        this.itemHeight = itemHeight
    }

    templateHtml() {
        return "<div class='dropdownContainer simpleListMenu <%=extraClass%>'></div>"
    }

    afterRender() {
        this.scrollView = new ScrollView(this.getEl(), this.itemHeight).init()
        var self = this;
        this.bindClick(function(clickEvent) {self.trigger('click', clickEvent.originalEvent);});
    }

    getItems() {
        return this.items
    }

    getItem(item) {
        return this.scrollView.getItems().find(itemContainer =>_.isEqual(itemContainer.getItemInformation(), item))
    }

    unselectAll() {
        this.selectItem(null)
    }

    selectItem(item) {
        this.scrollView.getItems().forEach(itemContainer => {
            itemContainer.setState({
                selected: _.isEqual(itemContainer.getItemInformation(), item),
            })
        })
    }

    setItems(items) {
        this.items = items;

        this.scrollView.setItems(items.map(item => new Item(item, this.itemHtmlCallback, this._itemClickHandler)));
    }

    onShow() {
        super.onShow();
        this.scrollView.refreshScroll();
    }

    mouseDownTargetElement() {
        return $('body')
    }

    _itemClickHandler = item => {
        this.onItemClick(item);
        this.hide();
    }
}

class Item extends TemplateView {
    constructor(item, itemHtmlCallback, clickHandler) {
        super();
        this.item = item;
        this.itemHtmlCallback = itemHtmlCallback;
        this.clickHandler = clickHandler;

        this.state = {
            selected: false,
        }

        this.onStatePropertyChanged('selected', this._handleSelection)
    }

    _handleSelection = () => {
        this.getEl() && this.getEl().toggleClass('selected', this.state.selected)
    }

    templateHtml() {
        return "<div class='item'></div>"
    }

    afterRender() {
        this.$el.html(this.itemHtmlCallback(this.item));
        this.$el.click(e => {
            this.clickHandler(this.item);
            e.stopPropagation();
        });
        this._handleSelection()
    }

    getItemInformation() {
        return this.item
    }
}

const defaultItemHtmlCallback = item => escapeHtmlSymbols(item.name);


// WEBPACK FOOTER //
// ./web/js/SimpleListMenu.js